import React from 'react';
import PropTypes from 'prop-types';
import ActionsMenu from 'components/ActionsMenu';
import { COMPANIES_LANDING_MENU } from 'utilities/menus';

// One column of the row, picked by `field`: the UI Kit table renders
// cell by cell.
const CompanyTableCell = ({ field, company, onAction }) => {
  const companyAddress = company?.address;
  const handleAction = action => onAction(action, company);

  const cells = {
    name: (
      <button
        type="button"
        className="font-bold text-left cursor-pointer"
        onClick={() => handleAction('view')}
      >
        {company?.name ? company.name : company.legalName}
      </button>
    ),
    city: companyAddress?.city,
    state: companyAddress?.state,
    actions: (
      <div
        data-testid="company-table-options-menu"
        className="absolute right-0 top-1/2 -translate-y-1/2 flex-none w-10 mr-2"
      >
        <ActionsMenu
          portal
          onAction={handleAction}
          options={COMPANIES_LANDING_MENU}
        />
      </div>
    )
  };

  return cells[field] ?? null;
};

CompanyTableCell.propTypes = {
  field: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  company: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.shape(),
    email: PropTypes.string,
    legalName: PropTypes.string
  }).isRequired
};

export default CompanyTableCell;
